export default __webpack_public_path__ + "static/media/printHeader.53385aa9.png";